import { render, staticRenderFns } from "./ElementsText.vue?vue&type=template&id=5bf36ef6&scoped=true"
import script from "./ElementsText.vue?vue&type=script&lang=js"
export * from "./ElementsText.vue?vue&type=script&lang=js"
import style0 from "./ElementsText.vue?vue&type=style&index=0&id=5bf36ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf36ef6",
  null
  
)

export default component.exports